import { useQueryClient } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import type { MarketParent } from 'shared/src/api/marketService/getMarketParent';

/** 부모 마켓 존재 여부 확인 */
export const useHasParentMarket = (marketId: number) => {
  const queryClient = useQueryClient();
  const parentMarketData = queryClient.getQueryData<MarketParent>(
    queryKey.marketParent(marketId),
  );

  const hasParentMarket = parentMarketData?.parent_market_sno != null;

  return { hasParentMarket };
};
